import {SignInParams} from 'domain/usecases/index.js';
import {makeRemoteAuthentication} from 'main/factories/usecases';

export async function remoteAuthentication(params: SignInParams) {
	const response = await makeRemoteAuthentication().auth(params);

	return response;
}
